'use client';
import {FC} from 'react';
import styles from './EventDescription.module.scss';
import {SingleEventInfo} from '@/models/EventModels';
import Image from 'next/image';
import UrlResolverComponent from "@/shared/UrlResolverComponent/UrlResolverComponent";
import OrganizationBadge from "@/shared/OrganizationBadge/OrganizationBadge";

interface EventDescriptionProps {
  className?: string;
  event_info?: SingleEventInfo;
}

const EventDescription: FC<EventDescriptionProps> = ({
                                                       className = '',
                                                       event_info
                                                     }) => {
  return (
    <div className={`${styles.root} ${className}`}>
      <Image
        width={820}
        height={500}
        className={styles.root__poster}
        style={{objectFit: 'cover'}}
        src={event_info?.poster_image || ''}
        alt={event_info?.title || ''}
      />

      <div className={styles.wrapper}>
        {/*<div className={styles.header__tickets}>*/}
        {/*  <span>*/}
        {/*    <Image src={Blizard} width="24" height="24" alt="blizard" />*/}
        {/*  </span>*/}
        {/*  <p> 15 tickets left</p>*/}
        {/*</div>*/}

        <h1 className={styles.root__title}>{event_info?.title}</h1>

        <OrganizationBadge
          className={styles.organization}
          name={event_info?.organization?.name || ''}
          logo={event_info?.organization?.image || ''}
          slug={event_info?.organization?.slug || ''}
          isVerified={!!event_info?.organization?.is_verified}
        />

        <UrlResolverComponent
          className={styles.root__description}
          text={event_info?.description || ''}/>
      </div>
    </div>
  );
};

export default EventDescription;
